/**
 * KEEP IT DUMB AND SIMPLE
 */
import { handleActions } from 'redux-actions';
import { setIsLoading, storeResult } from './actionCreators';
import { reduxKey } from './constants';
import { SimpleXHRStoreSlice } from './types';

const actionHandlers = handleActions<SimpleXHRStoreSlice, any>(
  {
    [setIsLoading.toString()]: (state, { payload: endpoint }: ReturnType<typeof setIsLoading>) => ({
      ...state,
      loadingEndpoints: [...state.loadingEndpoints, endpoint],
    }),
    [storeResult.toString()]: (
      state,
      { payload: { endpoint, result } }: ReturnType<typeof storeResult>
    ) => ({
      ...state,
      loadingEndpoints: state.loadingEndpoints.filter(e => e !== endpoint),
      results: {
        ...state.results,
        [endpoint]: result,
      },
    }),
  },
  {
    loadingEndpoints: [],
    results: {},
  }
);

const reducers = {
  [reduxKey as string]: actionHandlers,
};

export default reducers;
